package com.nonopn.skywatcher.maps.providers

import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform

class GoogleProvider : AbstractMapProvider(
    "google",
    currentPlatform != Platform.JS
) {
    override suspend fun buildUrl(row: Int, col: Int, zoomLvl: Int): String {
        val path = "${zoomLvl + 1}/$col/$row"
        return "https://api.lpsmanager.io/map/tile/$path"
    }
}